import { render, staticRenderFns } from "./DataComponentModelTable.vue?vue&type=template&id=5da8d8bc&scoped=true&"
import script from "./DataComponentModelTable.vue?vue&type=script&lang=js&"
export * from "./DataComponentModelTable.vue?vue&type=script&lang=js&"
import style0 from "./DataComponentModelTable.vue?vue&type=style&index=0&id=5da8d8bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da8d8bc",
  null
  
)

export default component.exports